import Vue from 'vue';
import VueHorizontal from 'vue-horizontal';

Vue.use(VueHorizontal);